module.exports = "<div class=\"quick-message\">\r\n\t<div class=\"quick-success animated slideInDown\">\r\n\t\t<span class=\"quick-icon ion-checkmark\"></span>\r\n\t\t<div class=\"quick-text\">\r\n\t\t\t<h4>SUCCESSFUL</h4>\r\n\t\t\t<p>{{ message }}</p>\r\n\t\t</div>\r\n\t\t<span class=\"ti-close\" (click)=\"closeModal()\"></span>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/modal-success-message/modal-success-message.component.html
// module id = ../../../../../src/app/_shared/layout/modal-success-message/modal-success-message.component.html
// module chunks = main